import { useState, useEffect } from "react";
import ChatbotComponent, {
  MessageModel,
} from "../../components/ChatbotComponent";
import { useAuth } from "../../context/AuthContext";
import { useSignInModal } from "../../context/SignInModalContext";

interface ChatWidgetProps {
  analysisId: string;
}

const ChatWidget: React.FC<ChatWidgetProps> = ({ analysisId }) => {
  const { isAuthenticated } = useAuth();
  const { openSignInModal } = useSignInModal();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState<MessageModel[]>([]);
  const [showChatHint, setShowChatHint] = useState(false);
  const [animateHint, setAnimateHint] = useState(false);

  useEffect(() => {
    setChatMessages([]);
    setIsChatOpen(false);
    setShowChatHint(false);
  }, [analysisId]);

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setShowChatHint(true);
      setAnimateHint(true);
      // Remove animation class after 10s
      setTimeout(() => setAnimateHint(false), 10000);
    }, 2500);
    const hideTimer = setTimeout(() => setShowChatHint(false), 10000); // Show for 10 seconds
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  useEffect(() => {
    if (isChatOpen) setShowChatHint(false);
  }, [isChatOpen]);

  return (
    <>
      <div className="chat-icon-wrapper">
        <i
          className={`fa-regular ${isChatOpen ? "fa-x" : "fa-comment"} chat-icon ${isChatOpen ? "opened" : ""}`}
          onClick={() => {
            if (!isAuthenticated) {
              openSignInModal();
            } else {
              setIsChatOpen(!isChatOpen);
            }
          }}
        />
        {showChatHint && !isChatOpen && (
          <div className={`chat-hint-bubble${animateHint ? " animated" : ""}`}>
            You can ask me anything about the file
          </div>
        )}
      </div>
      {isAuthenticated && isChatOpen && (
        <div className="chatbot-overlay">
          <div className="chatbot-container">
            <ChatbotComponent
              analysisId={analysisId}
              persistedMessages={chatMessages}
              onMessagesChange={setChatMessages}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
